import {AuthPage, ThemedTitleV2} from "@refinedev/mui";
import React from "react";
import {useTranslate} from "@refinedev/core";

export const Register = () => {
  const t = useTranslate();
  return (
      <AuthPage
          type="register"
          title={
            <ThemedTitleV2
                collapsed={false}
                wrapperStyles={{
                  gap: "8px",
                }}
                text={t('', '녹사평 AR Bridge 관리자')} />
          }
      />
  );
};
